export const buildMetrics = ({
    type = 'click',
    originalApplyUrl,
    category,
    company,
    hash,
    title,
    location,
    jobSearchQueryID,
    position,
    miscEventType,
    ctsName,
    ctsEvent,
}) => {
    return {
        apply_url: originalApplyUrl,
        company_id: [company.id],
        company_name: [company.name],
        job_category: category,
        job_slug: hash,
        job_title: title,
        location_name: location,
        position,
        search_id: jobSearchQueryID,
        [type]: 1,
        misc_event_type: miscEventType,
        jobs: [ctsName],
        ctsEvent,
    };
};

export const buildJobViewMetrics = ({
    originalApplyUrl,
    category,
    company,
    hash,
    title,
    location,
    jobSearchQueryID,
    miscEventType,
    impression,
}) => {
    return {
        apply_url: originalApplyUrl,
        company_id: [company.id],
        company_name: [company.name],
        job_category: category,
        job_slug: hash,
        job_title: title,
        location_name: location,
        search_id: jobSearchQueryID,
        misc_event_type: miscEventType,
        impression,
    };
};
